import React from 'react';
import {
  EXPERIMENT_BUCKET_CONTROL,
  EXPERIMENT_BUCKET_VARIANT
} from '../../lib/experimentBucket';

const defaultExperiment = Object.freeze({
  curiosity_explr03: EXPERIMENT_BUCKET_CONTROL
});

export const ExperimentContext = React.createContext(defaultExperiment);

export const computeExperimentFromFederatedId = _federatedId => {
  return {
    curiosity_explr03: EXPERIMENT_BUCKET_VARIANT
  };
};

export const withExperimentContext = Component => {
  const AugmentedComponent = props => (
    <ExperimentContext.Consumer>
      {experiments => <Component {...props} experiments={experiments} />}
    </ExperimentContext.Consumer>
  );
  AugmentedComponent.fragment = Component.fragment;
  AugmentedComponent.displayName = Component.displayName;
  return AugmentedComponent;
};
